var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCausesIconOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_756_3811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_756_3811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5C3.58333 19.5 3.22933 19.354 2.938 19.062C2.646 18.7707 2.5 18.4167 2.5 18V14.4C3.06667 14.3 3.54167 14.025 3.925 13.575C4.30833 13.125 4.5 12.6 4.5 12C4.5 11.4 4.30833 10.875 3.925 10.425C3.54167 9.975 3.06667 9.7 2.5 9.6V6C2.5 5.58333 2.646 5.22933 2.938 4.938C3.22933 4.646 3.58333 4.5 4 4.5H20C20.4167 4.5 20.7707 4.646 21.062 4.938C21.354 5.22933 21.5 5.58333 21.5 6V9.6C20.9333 9.7 20.4583 9.975 20.075 10.425C19.6917 10.875 19.5 11.4 19.5 12C19.5 12.6 19.6917 13.125 20.075 13.575C20.4583 14.025 20.9333 14.3 21.5 14.4V18C21.5 18.4167 21.354 18.7707 21.062 19.062C20.7707 19.354 20.4167 19.5 20 19.5H4ZM4 18H20V15.45C19.3833 15.0833 18.896 14.596 18.538 13.988C18.1793 13.3793 18 12.7167 18 12C18 11.2833 18.1793 10.6207 18.538 10.012C18.896 9.404 19.3833 8.91667 20 8.55V6H4V8.55C4.61667 8.91667 5.10433 9.404 5.463 10.012C5.821 10.6207 6 11.2833 6 12C6 12.7167 5.821 13.3793 5.463 13.988C5.10433 14.596 4.61667 15.0833 4 15.45V18ZM12 16.65C12.2167 16.65 12.396 16.5793 12.538 16.438C12.6793 16.296 12.75 16.1167 12.75 15.9C12.75 15.6833 12.6793 15.5043 12.538 15.363C12.396 15.221 12.2167 15.15 12 15.15C11.7833 15.15 11.6043 15.221 11.463 15.363C11.321 15.5043 11.25 15.6833 11.25 15.9C11.25 16.1167 11.321 16.296 11.463 16.438C11.6043 16.5793 11.7833 16.65 12 16.65ZM12 12.75C12.2167 12.75 12.396 12.679 12.538 12.537C12.6793 12.3957 12.75 12.2167 12.75 12C12.75 11.7833 12.6793 11.604 12.538 11.462C12.396 11.3207 12.2167 11.25 12 11.25C11.7833 11.25 11.6043 11.3207 11.463 11.462C11.321 11.604 11.25 11.7833 11.25 12C11.25 12.2167 11.321 12.3957 11.463 12.537C11.6043 12.679 11.7833 12.75 12 12.75ZM12 8.85C12.2167 8.85 12.396 8.779 12.538 8.637C12.6793 8.49567 12.75 8.31667 12.75 8.1C12.75 7.88333 12.6793 7.704 12.538 7.562C12.396 7.42067 12.2167 7.35 12 7.35C11.7833 7.35 11.6043 7.42067 11.463 7.562C11.321 7.704 11.25 7.88333 11.25 8.1C11.25 8.31667 11.321 8.49567 11.463 8.637C11.6043 8.779 11.7833 8.85 12 8.85Z",
    fill: "#BFBCB5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCausesIconOff);
export default __webpack_public_path__ + "static/media/causesIconOff.9c86fae34c6718a13ae96dc2530fc51c.svg";
export { ForwardRef as ReactComponent };